import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_BIDDERS_FOR_FORM } from './api/query'
import { Data, Variables, WorkspaceBidderSliceDTO } from './api/types'
import { DEFAULT_SORT } from './constants'
import { UseGetWorkspaceBidders, WorkspaceBidderSlice } from './types'

export const useGetWorkspaceBidders = (): UseGetWorkspaceBidders => {
  const { workspaceId } = useWorkspaceParam()
  const [workspaceBidders, setWorkspaceBidders] = useState<WorkspaceBidderSlice[]>([])

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        workspaceBidders: { nodes },
      } = data

      if (nodes) {
        setWorkspaceBidders(
          nodes.map(
            (workspaceBidder: WorkspaceBidderSliceDTO): WorkspaceBidderSlice =>
              fromDTO(workspaceBidder),
          ),
        )
      }
    },
    query: GET_WORKSPACE_BIDDERS_FOR_FORM,
    variables: {
      sort: DEFAULT_SORT,
      workspaceId,
    },
  })

  return {
    loading,
    workspaceBidders,
  }
}
